import {
  Box,
  Chip,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockIcon from '@mui/icons-material/Lock';
import { colors, toggleButtonStyles, chipStyles } from './styles';

/**
 * Component for displaying and toggling AIMe status
 */
function StatusToggle({
  enabled,
  isLoading,
  canToggleStatus,
  handleStatusChange
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant='h4'>AIMe Configuration</Typography>
        <Chip 
          label={isLoading ? 'Updating...' : (enabled ? 'Enabled' : 'Locked')}
          color={enabled ? 'success' : 'default'}
          style={chipStyles.getStatusChipStyle(enabled, isLoading)}
          icon={isLoading ? null : (enabled ? 
            <CheckCircleIcon sx={{ color: `${colors.enabled.text} !important` }} /> : 
            <LockIcon sx={{ color: `${colors.locked.text} !important` }} />)}
          size="small"
          variant="outlined"
        />
      </Box>
      {canToggleStatus && (
        <ToggleButtonGroup
          value={enabled ? 'enabled' : 'locked'}
          exclusive
          onChange={handleStatusChange}
          size="small"
          disabled={isLoading}
          sx={{ borderRadius: '6px' }}
        >
          <ToggleButton 
            value="enabled"
            sx={toggleButtonStyles.enabled(enabled)}>
            {isLoading && enabled ? 'Enabling...' : 'Enabled'}
          </ToggleButton>
          <ToggleButton 
            value="locked"
            sx={toggleButtonStyles.locked(!enabled)}>
            {isLoading && !enabled ? 'Locking...' : 'Locked'}
          </ToggleButton>
        </ToggleButtonGroup>
      )}
    </Box>
  );
}

export default StatusToggle;
